import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/seniors_training.jpg";
import Tilt from "react-parallax-tilt";


import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";


function Senior2() {

  const navigate = useNavigate(); // Initialize navigate

  const handleClick = () => {
    navigate("#"); // This will navigate to the "/another-page" route
  };




    const videoId = "5mPU-mIQgoQ"; 
return (
    <Container fluid className="home-about-section" id="about">
    <Container>
        <Row>
        <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
            Empowering<span className="purple"> Seniors</span> with Technology
            </h1>
            <p className="home-about-body">
            Choicest Fruit® is committed to enriching the lives of senior citizens through our  <b className="purple">Digital Literacy Program for Seniors</b>,
            designed to equip them with the skills needed to thrive in today’s technology-driven world. Offered at the Montopolis Recreation and Community
            Center in Austin, this hands-on program provides seniors with the tools to confidently use smartphones, computers, and navigate the internet.
            Participants will gain essential digital skills, including how to stay connected with loved ones, access online services, cyber security
            , troubleshooting, and explore educational resources that enhance their lives.
            <br />
            <br />Beyond technical proficiency, our program promotes lifelong learning, fostering cognitive health, creativity,
            and personal growth. Through interactive lessons, seniors engage in activities that stimulate their minds while
            building their confidence in using modern technology. The Digital Literacy Program offers more than just device
            training—it strengthens independence, social inclusion, and provides seniors with the opportunity to remain active,
            engaged, and connected to their communities. We believe that digital literacy is an essential part of empowering
            seniors and enriching their quality of life. By offering this program, we aim to bridge the digital divide, helping
            seniors unlock new opportunities for personal development, social connection, and access to services, ultimately
            leading to a more fulfilling and independent life.
            <br />
            <br />
            
          </p>
          <Button onClick={handleClick}>Volunteer</Button>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>SUMMER INTERNSHIP PROGRAM</h1>
          <Container>    
      
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', maxWidth: '100%', marginBottom: '20px' }}>
                                <iframe
                                    title="YouTube video"
                                    src={`https://www.youtube.com/embed/${videoId}`}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                    }}
                                />
      </div>
    </Container>
           
          </Col>
            </Row>

            
                <Col md={12} className="home-testimonial">
                <h1>TESTIMONIALS</h1>
                </Col>
          
            


      </Container>
    </Container>
  );
}
export default Senior2;
